import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white p-6 rounded-lg border" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4 text-center" }, "Tareas Finalizadas por Proceso", -1)
const _hoisted_3 = { class: "flex justify-center items-center h-[calc(100%-3rem)]" }

import { watchEffect, ref } from 'vue';
import { Chart } from 'chart.js/auto';
import ICountTaskByProcess from '@/interfaces/ICountTaskByProcess';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartByProcess',
  props: {
    items: {
        type: Array as () => Array<ICountTaskByProcess>,
        required: true
    }
},
  setup(__props) {

const props = __props;

const chartCanvas = ref<HTMLCanvasElement | null>(null);
let chart: Chart | null = null;

const createChart = () => {
    if (!chartCanvas.value) return;
    
    if (chart) {
        chart.destroy();
    }

    if (props.items.length > 0) {
        chart = new Chart(chartCanvas.value, {
            type: 'bar',
            data: {
                labels: props.items.map(item => item.process),
                datasets: [{
                    label: 'Cantidad de tareas',
                    data: props.items.map(item => item.count),
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.7)',
                        'rgba(54, 162, 235, 0.7)',
                        'rgba(255, 206, 86, 0.7)',
                        'rgba(75, 192, 192, 0.7)',
                        'rgba(153, 102, 255, 0.7)',
                        'rgba(255, 159, 64, 0.7)',
                        'rgba(0, 153, 204, 0.7)',
                        'rgba(255, 99, 255, 0.7)',
                        'rgba(45, 192, 86, 0.7)'
                    ],
                    borderColor: [
                        'rgb(255, 99, 132)',
                        'rgb(54, 162, 235)',
                        'rgb(255, 206, 86)',
                        'rgb(75, 192, 192)',
                        'rgb(153, 102, 255)',
                        'rgb(255, 159, 64)',
                        'rgb(0, 153, 204)',
                        'rgb(255, 99, 255)',
                        'rgb(45, 192, 86)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        display: false
                    },
                    title: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        beginAtZero: true
                    }
                },
                animation: {
                    duration: 1500,
                    easing: 'easeOutQuart',
                    delay: (context) => {
                        return context.dataIndex * 100;
                    }
                }
            }
        });
    }
};

watchEffect(() => {
    if (chartCanvas.value) {
        createChart();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("canvas", {
        ref_key: "chartCanvas",
        ref: chartCanvas,
        id: "chartByProcess"
      }, null, 512)
    ])
  ]))
}
}

})